import Vue from 'vue';
import { COLOR_PAGE_BG } from '@/theme';
import { setDocumentTitle } from '@/util';
export default Vue.extend({
    name: 'FullGiftMyReward',
    data() {
        return {
            COLOR_PAGE_BG,
            loading: false,
            list: [],
            // 首次挂载时快照路由参数，避免 iOS bfcache 恢复时 $route 短暂为空导致丢参
            activityId: '',
        };
    },
    async mounted() {
        setDocumentTitle('我的奖品');
        this.activityId = this.$route.query.activity_id || '';
        await this.fetchList();
    },
    methods: {
        async fetchList() {
            this.loading = true;
            try {
                const { data } = await this.$axios.get('/api/activity/fullGift/fullGift/myClaims', {
                    params: { activity_id: this.activityId },
                });
                this.list = (data && data.list) || [];
            }
            catch {
                // errors handled silently; page stays in loading=false state
            }
            finally {
                this.loading = false;
            }
        },
        fmtTime(time) {
            if (!time)
                return '';
            // iOS 无法解析「2026-06-20 10:00:00」格式，需替换连字符
            return new Date(time.replace(/-/g, '/')).format('YYYY.MM.DD hh:mm:ss');
        },
        goDetail(claim) {
            // 跳转至奖品订单详情（商城侧），以发奖单号查询发货进度
            window.location.href = `${window.location.origin}/goods/orderDetail?tid=${claim.prize_order_no}`;
            // window.location.href = `http://m.ivydad.com.cn/goods/orderDetail?tid=${claim.prize_order_no}`
        },
    },
});
